import useFetch from '@hooks/useFetch';

const useLessonPlayListDetails = (
  playlistUID,
  options = { fallbackData: undefined }
) => {
  const key = `v1/curated_content/${playlistUID}/content-details?limit=100&offset=0`;
  const {
    data: lessonPlaylistDetails,
    mutate,
    ...rest
  } = useFetch(key, {}, { fallbackData: options.fallbackData });

  return {
    key,
    lessonPlaylistDetails,
    mutate,
    ...rest
  };
};

export default useLessonPlayListDetails;
